import React, { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Button } from "./ui/button";
import { ArrowRight, Users, MapPin, MousePointerClick } from "lucide-react";

export default function MoveAllHorsesModal({
  isOpen,
  onClose,
  sourceZone,
  zones,
  horses,
  onConfirm, // fonction à appeler à la fin avec la targetZone
  onStartMoveFromMap // fonction à appeler si "Déplacer depuis la carte"
}) {
  const [targetZoneId, setTargetZoneId] = useState("");

  if (!isOpen || !sourceZone) return null;
  const targetZone = zones.find(z => z.id === targetZoneId);

  return (
    <Dialog open={isOpen} onClose={onClose} className="fixed z-[10001] inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="fixed inset-0 bg-black opacity-30" aria-hidden="true" />
        <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6 z-50">
          <Dialog.Title className="text-xl font-semibold mb-4 flex items-center gap-2">
            <Users className="h-5 w-5 text-blue-600" />
            Déplacer tous les chevaux de {sourceZone.name}
          </Dialog.Title>
          <div className="space-y-4">
            <div>
              <label className="block mb-2 text-sm text-gray-600">
                Choisir la zone d’arrivée
              </label>
              <select
                className="w-full border p-2 rounded"
                value={targetZoneId}
                onChange={e => setTargetZoneId(e.target.value)}
              >
                <option value="">Sélectionnez une zone</option>
                {zones.filter(z => z.id !== sourceZone.id).map(z =>
                  <option key={z.id} value={z.id}>{z.name} ({z.type})</option>
                )}
              </select>
            </div>
            <Button
              variant="outline"
              className="w-full flex items-center justify-center gap-2"
              onClick={() => onStartMoveFromMap()}
            >
              <MousePointerClick className="h-5 w-5 text-blue-700" />
              Déplacer depuis la carte
            </Button>
            <div className="p-3 bg-blue-50 rounded border border-blue-200">
              <MapPin className="inline h-4 w-4 text-blue-600 mr-1" />
              <span>
                {horses.length} cheval{horses.length > 1 ? "x" : ""} concerné{horses.length > 1 ? "s" : ""} 
                de <strong>{sourceZone.name}</strong>
                {targetZone ? <> → <strong>{targetZone.name}</strong></> : null}
              </span>
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-6">
            <Button variant="outline" onClick={onClose}>Annuler</Button>
            <Button
              variant="default"
              onClick={() => onConfirm(targetZone)}
              disabled={!targetZone}
            >
              <ArrowRight className="h-4 w-4 mr-1" />
              Confirmer le déplacement
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
